import React, { useEffect, useState } from "react"

// Mui
import {
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  ListItem,
  ListItemText,
  Stack,
  Typography,
  useTheme
} from "@mui/material"

// Services
import moment from "jalali-moment"
import { toast } from "react-toastify"
import ticketServices from "src/services/tickets"

// ---------------------------------------------------------------------------------------------------------------------

const TicketInfo = ({ open, setOpen, ticket }) => {
  const theme = useTheme()

  const [state, setState] = useState("loading" | "error" | "done")
  const [data, setData] = useState()

  const closeDialog = () => {
    setOpen(perv => ({ ...perv, info: false }))
  }

  const getTicketInfo = () => {
    setState("loading")
    ticketServices?.getTicketInfo(ticket?.id).then(response => {
      if (response?.status === 200) {
        if (!response?.data?.succeed) {
          setState("error")
          toast.error(response?.data?.message)
        } else {
          setData(response?.data?.value)
          setState("done")
        }
      }
    })
  }

  useEffect(() => {
    if (open) {
      getTicketInfo()
    }
  }, [open])

  return (
    <Dialog open={open} fullWidth maxWidth='sm' onClose={closeDialog} PaperProps={{ sx: { borderRadius: "15px" } }}>
      <DialogContent>
        {state === "loading" ? (
          <Stack direction='row' justifyContent='center' my={3}>
            <CircularProgress size={30} />
          </Stack>
        ) : (
          <>
            <Typography variant='h5'>{ticket?.type}</Typography>

            <Grid container spacing={1} sx={{ mt: 2 }}>
              <Grid item xs={6}>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography variant='subtitle1' color='primary'>
                        نوع درخواست پشتیبانی
                      </Typography>
                    }
                    secondary={
                      <Typography variant='h6' fontWeight={400}>
                        {data?.type}
                      </Typography>
                    }
                  />
                </ListItem>
              </Grid>
              <Grid item xs={6}>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography variant='subtitle1' color='primary'>
                        وضعیت درخواست پشتیبانی
                      </Typography>
                    }
                    secondary={
                      <Typography variant='h6' fontWeight={400}>
                        {data?.statusName}
                      </Typography>
                    }
                  />
                </ListItem>
              </Grid>
              <Grid item xs={6}>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography variant='subtitle1' color='primary'>
                        کد پیگیری
                      </Typography>
                    }
                    secondary={
                      <Typography variant='h6' fontWeight={400}>
                        {data?.trackingCode}
                      </Typography>
                    }
                  />
                </ListItem>
              </Grid>
              <Grid item xs={6}>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography variant='subtitle1' color='primary'>
                        تاریخ ساخت درخواست پشتیبانی
                      </Typography>
                    }
                    secondary={
                      <Typography variant='h6' fontWeight={400}>
                        {moment(data?.createDate).locale("fa").format("YYYY/M/D HH:mm:ss")}
                      </Typography>
                    }
                  />
                </ListItem>
              </Grid>
              <Grid item xs={6}>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography variant='subtitle1' color='primary'>
                        شناسه پرداخت
                      </Typography>
                    }
                    secondary={
                      <Typography variant='h6' fontWeight={400}>
                        {data?.purchaseId}
                      </Typography>
                    }
                  />
                </ListItem>
              </Grid>
              {data?.ticketFile && (
                <Grid item xs={12} md={6}>
                  <ListItem>
                    <ListItemText
                      primary={
                        <Typography variant='subtitle1' color='primary'>
                          تصویر
                        </Typography>
                      }
                      secondary={<img alt='Ticket Image' width={"90%"} height='180' src={data?.ticketFile} />}
                    />
                  </ListItem>
                </Grid>
              )}

              <Grid item xs={12}>
                <ListItem>
                  <ListItemText
                    primary={
                      <Typography variant='subtitle1' color='primary'>
                        پیام
                      </Typography>
                    }
                    secondary={
                      <Typography variant='h6' fontWeight={400}>
                        {data?.message}
                      </Typography>
                    }
                  />
                </ListItem>
              </Grid>
              {data?.status !== 1301 && (
                <Grid item xs={6}>
                  <ListItem>
                    <ListItemText
                      primary={
                        <Typography variant='subtitle1' color='primary'>
                          پاسخ
                        </Typography>
                      }
                      secondary={
                        <Typography variant='h6' fontWeight={400}>
                          {data?.response}
                        </Typography>
                      }
                    />
                  </ListItem>
                </Grid>
              )}
            </Grid>

            <Stack mt={3} direction='row' justifyContent='end' alignItems='center' spacing={1}>
              <Button variant='text' color='inherit' onClick={closeDialog}>
                بستن
              </Button>
            </Stack>
          </>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default TicketInfo
